module.exports = __webpack_public_path__ + "static/media/nestedlookahead_scr.43de95cb.png";